import { render, staticRenderFns } from "./FBAOrder.vue?vue&type=template&id=67d20366&scoped=true"
import script from "./FBAOrder.vue?vue&type=script&lang=js"
export * from "./FBAOrder.vue?vue&type=script&lang=js"
import style0 from "./FBAOrder.vue?vue&type=style&index=0&id=67d20366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20366",
  null
  
)

export default component.exports